import { getDealsBannerText } from '../../../../utils/getDealsBannerText';
import type { TDealsBannerConfig } from '../../../../types/dealsBannerConfig';
import type { IDealsLeadFormBlockProps } from '../../../../components/DealsLeadForm';
import type { IDealsBannerProps } from '../../../../components/DealsBanner';

/**
 * Собирает пропсы DealsBanner, если статья есть в RS dealsBannerConfig.
 * Заголовок формы (formTitle/formSubtitle) переиспользуется из уже собранных
 * пропсов формы лида (dealsLeadForm), т.к. модалка баннера — та же форма.
 * Группа эксперимента здесь не учитывается — её проверяет DealsExperimentArticle.
 */
export const getDealsBannerProps = (
  postId: number,
  dealsLeadForm: IDealsLeadFormBlockProps | undefined,
  dealsBannerConfig: TDealsBannerConfig | null,
): IDealsBannerProps | undefined => {
  if (!dealsLeadForm) {
    return undefined;
  }

  const bannerText = getDealsBannerText(postId, dealsBannerConfig);

  if (!bannerText) {
    return undefined;
  }

  return {
    title: bannerText.title,
    formTitle: dealsLeadForm.title,
    formSubtitle: dealsLeadForm.subtitle,
    regionOptions: dealsLeadForm.regionOptions,
    postId,
  };
};
